const messages = {
  editEvent: 'Edit Event',
  selectOne: 'Select one',
  selectOption: 'Select an option to edit your order event',
  update: 'Update',
}

export default messages
